"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationCheckResultStatus = void 0;
exports.createSkippedValidationEntries = createSkippedValidationEntries;
exports.filterToFailedValidationResults = filterToFailedValidationResults;
exports.compactValidationResults = compactValidationResults;
var ValidationCheckResultStatus;
(function (ValidationCheckResultStatus) {
    ValidationCheckResultStatus["pass"] = "pass";
    ValidationCheckResultStatus["fail"] = "fail";
    ValidationCheckResultStatus["skipped"] = "skipped";
})(ValidationCheckResultStatus || (exports.ValidationCheckResultStatus = ValidationCheckResultStatus = {}));
function createSkippedValidationEntries(results, errorTypeEnum) {
    const allValidationTypes = Object.values(errorTypeEnum);
    const typesInResults = new Set(results.map((result) => result.type));
    const missingTypes = allValidationTypes.filter((type) => !typesInResults.has(type));
    const skippedEntries = [];
    for (const missingType of missingTypes) {
        skippedEntries.push({
            type: missingType,
            result: ValidationCheckResultStatus.skipped,
            message: 'Check was not performed',
        });
    }
    return skippedEntries;
}
function filterToFailedValidationResults(results) {
    return results.filter((entry) => entry.result === ValidationCheckResultStatus.fail);
}
function compactValidationResults(results) {
    if (results.length === 0) {
        return [];
    }
    const resultsByType = new Map();
    for (const result of results) {
        const existing = resultsByType.get(result.type);
        if (existing) {
            existing.push(result);
        }
        else {
            resultsByType.set(result.type, [result]);
        }
    }
    const compactedResults = [];
    for (const [_type, typeResults] of resultsByType) {
        const failures = typeResults.filter((r) => r.result === ValidationCheckResultStatus.fail);
        const passes = typeResults.filter((r) => r.result === ValidationCheckResultStatus.pass);
        const skipped = typeResults.filter((r) => r.result === ValidationCheckResultStatus.skipped);
        if (failures.length > 0) {
            compactedResults.push(...failures);
        }
        else if (passes.length > 0) {
            compactedResults.push(passes[0]);
        }
        else if (skipped.length > 0) {
            compactedResults.push(skipped[0]);
        }
    }
    const statusPriority = {
        [ValidationCheckResultStatus.pass]: 1,
        [ValidationCheckResultStatus.fail]: 2,
        [ValidationCheckResultStatus.skipped]: 3,
    };
    compactedResults.sort((a, b) => {
        const statusDiff = statusPriority[a.result] - statusPriority[b.result];
        if (statusDiff !== 0) {
            return statusDiff;
        }
        return a.type.localeCompare(b.type);
    });
    return compactedResults;
}
//# sourceMappingURL=validation-check-result.js.map